import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img1 from '../assets/others/11102039.jpg'
import img2 from '../assets/icons/user-1.png'
import img3 from '../assets/others/11102040.png'
import { Helmet } from 'react-helmet'

const Joinus = () => {
  return (
    <div>
        <Helmet>
        <title>Why Join Takshila VLSI Institute for Career Growth | Takshila VLSI</title>
        <meta name="description" content="Find out why Takshila VLSI is the right choice for your career growth. Industry experts, practical training, and placements. Enroll today to get started now!" />
        <link rel="canonical" href="https://www.takshila-vlsi.com/why-join-us/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Why Join Takshila VLSI Institute for Career Growth | Takshila VLSI" />
        <meta property="og:description" content="Find out why Takshila VLSI is the right choice for your career growth. Industry experts, practical training, and placements. Enroll today to get started now!" />
        <meta property="og:url" content="https://www.takshila-vlsi.com/why-join-us/" />
        <meta property="og:site_name" content="Takshila VLSI" />
        <meta property="article:modified_time" content="2019-11-08T11:40:48+00:00" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <Header/>
        <main>
            <section className='section-banner pg-banner'>
            <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md p-5">
                                <div class="pg-title-sec pl-r-12">
                                    <h1 className='pg-title pb-3'>Why Join Us</h1>
                                    <p className='pg-title-desc'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.
                                    </p>
                                </div>
                              </div>
                          </div>
                          <div className='row p-lg-5 justify-content-center'>
                          <div class="col-lg-7">
                          <img src={img1} alt=''/>
                          </div>
                          
                          </div>
            </div>
            </section>
            <section className='ws-section winning-sec pb-5'>
            <div class="container">
                    <div class="row">
                        <div class="col-lg text-center">
                        <h2 className='ws-section_heading'>Our Winning Difference</h2>
                        <div class="wpb_wrapper mb-5">
                            <p>As a vital aspect of Takshila Training Institute, we believe in delivering high-quality coaching to our students. We impart our student with project-based hands-on training. We ensure that every project undertaken by our students has relevance and significance in the industry. Furthermore, students tutored by our team of experts possess the skill required to embark in any role as required in the industry.</p>
                            <p>There are four reasons why many choose us for their ASIC verification, Custom IC Mask/Analog Layout Design, and Physical Design certification.</p>
                        </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                        <div class="row">
                            <div class="col-lg-6">
                                <div className='icon-card bg-10 radius-1 mb-3'>
                                    <div className='icon mb-3'> <img src={img2} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-2'>Course delivered by Experts</div>
                                        <p>Experts in the industry teach our various courses to students. At Takshila, our experts share their experience and help build the career of our students in the VLSI industry. You have the opportunity of carrying out practical applications and examples.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                            <div className='icon-card bg-10 radius-1 mb-3'>
                                    <div className='icon mb-3'> <img src={img2} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-2'>100% placement support</div>
                                        <p>Our main goal is to help engineers build a successful career in the VLSI industry. Not only we do train you, but we also coach you in order to become a best Chip Designer. Our training process allows students to learn even complex technologies within a short time space and transforming them into professionals in no time. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                            <div className='icon-card bg-10 radius-1 mb-3'>
                                    <div className='icon mb-3'> <img src={img2} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-2'>Superior Training infrastructure and Methodology</div>
                                        <p>Industry experts carefully designed the training program based on the career growth and job opportunities available in the VLSI industry. We use an unique training methodology for our students with 70% of the course time allocated to the labs, mini-projects, and the final projects. However, the other 30% is allocated to imparting the technologies to our student.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                            <div className='icon-card bg-10 radius-1 mb-3'>
                                    <div className='icon mb-3'> <img src={img2} alt=''/></div>
                                    <div className='icon-content'>
                                    <div className='icon-card-head mb-2'>Powerful EDA Tools
                                        </div>
                                        <p>We utilize industrial standard EDA tools for hands-on training of our students. During your period as a trainee in our VLSI institute, EDA tools are accessible 24×7 through our vpn service.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div class="col-lg-6">
                        <img src={img3} alt=''/>
                        </div>
                    </div>
                    </div>
            </section>
        </main>
        <Enrollaction/>
        <Partnersec/> 
        <Footer/>

    </div>
  )
}

export default Joinus